import { THERMACUBE_CHECKOUT_URL } from './storeUrls';
import { THERMACUBE_PRODUCT_STUDIO } from './thermaCube';

/**
 * Curated homepage shelf — copy, imagery, Shopify URLs. Prices come from
 * `enrichHomepageLineup` + live catalog (see `useEnrichedHomepageLineup`).
 * Handles must match Shopify `handle` (see catalog-fallback.json / products.json).
 */
export const HOMEPAGE_PRODUCT_LINEUP_TEMPLATE = [
  {
    id: 'thermacube',
    shopifyHandle: 'thermacube-hot-cold-therapy-device',
    name: 'ThermaCube',
    category: 'Contrast therapy',
    blurb:
      'Wearable heat, cold, and automated contrast cycles—clinical-style thermal windows without two devices or a stopwatch.',
    image: THERMACUBE_PRODUCT_STUDIO,
    shopUrl: THERMACUBE_CHECKOUT_URL,
    detailPath: '/products',
  },
  {
    id: 'protherm',
    shopifyHandle: 'sprintfit-protherm-hot-cold-therapy-massage-gun',
    name: 'ProTherma',
    category: 'Massage',
    blurb:
      'Hot-and-cold percussion massage gun—deep tissue work and thermal attachment sessions without booking a table.',
    image:
      'https://cdn.shopify.com/s/files/1/0777/8369/5582/files/therapygun1.jpg?v=1776088707',
    shopUrl: 'https://www.sprintfit.in/products/sprintfit-protherm-hot-cold-therapy-massage-gun',
  },
  {
    id: 'kneerevive',
    shopifyHandle: 'kneerevive-pro-heat-and-vibration-therapy-for-knees',
    name: 'KneeRevive Pro',
    category: 'Targeted heat',
    blurb:
      'Heat plus vibration programmes built around the knee—post-squat, post-run, post-stairs relief at home.',
    image:
      'https://cdn.shopify.com/s/files/1/0777/8369/5582/files/heroimagekneerevive.jpg?v=1776081547',
    shopUrl: 'https://www.sprintfit.in/products/kneerevive-pro-heat-and-vibration-therapy-for-knees',
  },
  {
    id: 'shoulderease',
    shopifyHandle: 'shoulderease-heat-and-vibration-massager-combo',
    name: 'ShoulderEase',
    category: 'Targeted heat',
    blurb:
      'Heat, vibration, and magnetic-control shoulder protocols—desk hunch and lift-day tightness without a full rig.',
    image:
      'https://cdn.shopify.com/s/files/1/0777/8369/5582/files/shoulderease101.jpg?v=1776112268',
    shopUrl: 'https://www.sprintfit.in/products/shoulderease-heat-and-vibration-massager-combo',
  },
  {
    id: 'shoulderease-flex',
    shopifyHandle: 'shoulderease-flex-heat-and-vibration-magnetic-controlled-shoulder-massager-copy',
    name: 'ShoulderEase Flex Pro',
    category: 'Targeted heat',
    blurb:
      'Hassle-free shoulder wrap with heat and vibration—magnetic fit and stronger programmes for daily wear.',
    image:
      'https://cdn.shopify.com/s/files/1/0777/8369/5582/files/SHOULDERMAX1_bb6d3ccf-ba67-4ff6-a918-7b00bd6ee38d.jpg?v=1776116191',
    shopUrl:
      'https://www.sprintfit.in/products/shoulderease-flex-heat-and-vibration-magnetic-controlled-shoulder-massager-copy',
  },
  {
    id: 'pulsepad',
    shopifyHandle: 'sprintfit-pulsecore-smart-muscle-activation-recovery-device',
    name: 'PulsePad',
    category: 'TENS / EMS',
    blurb:
      'Wireless TENS + EMS pocket device—muscle activation and recovery sessions you can run from the couch.',
    image: 'https://cdn.shopify.com/s/files/1/0777/8369/5582/files/tens_ems6.jpg?v=1776091516',
    shopUrl:
      'https://www.sprintfit.in/products/sprintfit-pulsecore-smart-muscle-activation-recovery-device',
  },
  {
    id: 'fasciablade',
    shopifyHandle: 'sprintfit-fasciablade™-3-in-1-heated-fascia-massager-microcurrent-heat-vibration',
    name: 'FasciaBlade',
    category: 'Fascia & massage',
    blurb:
      '3-in-1 heated fascia tool—microcurrent, heat, and vibration in one grip for stubborn knots and warm-up.',
    image: 'https://cdn.shopify.com/s/files/1/0777/8369/5582/files/fascia1.jpg?v=1776104677',
    shopUrl:
      'https://www.sprintfit.in/products/sprintfit-fasciablade%E2%84%A2-3-in-1-heated-fascia-massager-microcurrent-heat-vibration',
  },
];

/** Body map + legacy imports: same rows without catalog prices (use enriched lineup when pricing matters). */
export const HOMEPAGE_PRODUCT_LINEUP = HOMEPAGE_PRODUCT_LINEUP_TEMPLATE;
